import styled from "@emotion/styled"
import { breakpoint, spacingFluidMd, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import { Grid } from "../grid/Grid"
import { GridItem } from "../grid/GridItem"
import { Skeleton } from "../skeleton"
import { FinancingFormProductDetailsSkeleton } from "./FinancingFormProductDetailsSkeleton"

export const FinancingFormSkeleton = () => (
	<Layout>
		<Skeleton.TabsBar background="surface" />

		<StyledGrid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }} $rowGap={spacingFluidMd}>
			<ProductSelectLayout size={{ base: 12, m: 4 }}>
				<Skeleton.RadioGroup count={3} />
			</ProductSelectLayout>
			<GridItem size={{ base: 12, m: 8 }}>
				<FinancingFormProductDetailsSkeleton />
			</GridItem>
		</StyledGrid>
	</Layout>
)

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingFluidMd};
	min-height: 25vh;
`

const StyledGrid = styled(Grid)`
	flex-grow: 1;
`

const ProductSelectLayout = styled(GridItem)`
	@media (min-width: ${breakpoint.m}px) {
		position: relative;

		&:after {
			content: '';
			position: absolute;
			top: 0;
			bottom: 0;
			inset-inline-end: calc(${spacingFluidXl} / -2);
			width: 1px;
			background: rgb(227, 228, 229);
		}
	}
`
